import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateProgramTemplateFooterWrapper = styled.div`
  margin: 16px 0px;
  background-color: ${COLORS.cirrus_white};
  padding: 32px 16px 20px;
  display: flex;
  justify-content: end;
  gap: 16px;

  ${responsive.MOBILE`
    margin: 0px 0px;
    flex-direction: column-reverse;
    padding: 16px 8px;

    button {
      width: 100%;
    }
  `}
`;

export const DiscardMessageWrapper = styled.div`
  .confirm-message {
    color: ${COLORS.cirrus_black10};
  }
`;
